module.exports = __webpack_public_path__ + "static/media/pipeline_icon.1fa0cca3.svg";